export const API_SHOWINGS_DEFAULT_LIMIT = 10;
